import { render, staticRenderFns } from "./playingSymbol.vue?vue&type=template&id=48a3e0ef"
import script from "./playingSymbol.vue?vue&type=script&lang=js"
export * from "./playingSymbol.vue?vue&type=script&lang=js"
import style0 from "./playingSymbol.vue?vue&type=style&index=0&id=48a3e0ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports